import MiniMarkdown, { splitMarkdownSections } from '../../utils/miniMarkdown';
import DebriefTrackMap from './DebriefTrackMap';
import {
  composeSessionRecapSlots,
  composeSessionRecapSections,
  sessionRecapErrorMessage,
} from '../../utils/sessionRecap';
import styles from './SessionRecapContent.module.css';

function withoutSectionHeading(markdown) {
  return (markdown || '').replace(/^#{1,4}\s+[^\n]+\n?/, '').trim();
}

export default function SessionRecapContent({ recap, variant = 'panel', trackMapData = null }) {
  if (!recap) return null;

  const slots = recap.meta
    ? composeSessionRecapSlots(
      recap.text,
      recap.meta.whereTimeMarkdown,
      recap.meta.nextSessionFocusMarkdown,
      recap.meta.carHealthMarkdown,
    )
    : null;
  const sections = !slots && recap.text
    ? (composeSessionRecapSections(
      recap.text,
      recap.meta?.whereTimeMarkdown,
      recap.meta?.nextSessionFocusMarkdown,
    ) || splitMarkdownSections(recap.text))
    : [];

  return (
    <div className={`${styles.content} ${styles[variant] || ''}`}>
      {recap.status !== 'error' && recap.meta?.headline && (
        <div className={styles.headline}>{recap.meta.headline}</div>
      )}
      {recap.status === 'error' ? (
        <div className={styles.error}>{sessionRecapErrorMessage(recap.error)}</div>
      ) : slots ? (
        <div className={styles.grid}>
          {slots.map(slot => slot.markdown ? (
            slot.id === 'where-time' && trackMapData ? (
              <div key={slot.id} className={styles.prose}>
                <h2>{slot.title}</h2>
                <div className={styles.whereBody}>
                  <DebriefTrackMap {...trackMapData} />
                  <MiniMarkdown text={withoutSectionHeading(slot.markdown)} className={styles.whereText} />
                </div>
              </div>
            ) : (
              <MiniMarkdown key={slot.id} text={slot.markdown} className={styles.prose} />
            )
          ) : (
            <div key={slot.id} className={`${styles.prose} ${styles.placeholder}`} aria-busy="true">
              <h2>{slot.title}</h2>
              <span>Generating this section…</span>
            </div>
          ))}
        </div>
      ) : sections.length ? (
        <div className={styles.grid}>
          {sections.map((section, index) => (
            <MiniMarkdown key={index} text={section} className={styles.prose} />
          ))}
        </div>
      ) : (
        <div className={styles.working}>
          <span className={styles.scan} aria-hidden="true"><i /><i /><i /></span>
          <span>Analyzing this session and the driver’s history…</span>
        </div>
      )}
    </div>
  );
}
